import { Skeleton as SkeletonShell } from '../ui/Skeleton';

/**
 * The alias older widgets call. Same single prop, now the shared skeleton:
 * rounded, `surface-dim`, and hidden from the accessibility tree like every
 * other placeholder in the app.
 */
export const Skeleton = ({ className }: { className?: string }) => <SkeletonShell className={className} />;
